import React from 'react';

import { Gas, History, TelaTransmiteCentral } from './components';
import { Container } from './styles';

export default function Dashboard() {
  return (
    <Container>
      <div className="row abastecimento">
        <TelaTransmiteCentral />
        {/* <Gas />
        <History /> */}
      </div>
    </Container>
  );
}
